import { render, staticRenderFns } from "./StoreUpdateNotificationSettings.vue?vue&type=template&id=3ccd345b&scoped=true&"
import script from "./StoreUpdateNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./StoreUpdateNotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccd345b",
  null
  
)

export default component.exports